import axios from 'axios';
import { delay } from 'redux-saga';
import { call, cancel } from 'redux-saga/effects';

const DEFAULT_RETRIES = 3;

export const FETCH = 'FETCH';

export function fetchEndpoint({ url, data }) {
  return {
    type: FETCH,
    url,
    data,
  };
}

export function* fetch(action) {
  const retries = action.retries ? DEFAULT_RETRIES : 1;
  for (let i = 0; i < retries; i += 1) {
    try {
      const { url, data } = action;
      const result = yield call(axios, {
        method: action.method || 'post',
        withCredentials: true,
        url,
        data,
      });
      return result;
    } catch (err) {
      if (i < retries) {
        yield call(delay, 2000);
      }
    }
  }
  yield cancel();
  throw new Error('API request failed');
}

export function* singleFetch(action) {
  const { url, data } = action;
  return yield call(axios, {
    method: action.method || 'post',
    withCredentials: true,
    url,
    data,
  });
}



// WEBPACK FOOTER //
// ./src/_app/middleware/fetch.js